<div
  role="button"
  (click)="menu.toggle($event)"
  class="flex items-center gap-3 p-2 rounded-border transition-colors hover:bg-surface-800 hover:text-surface-100 min-w-0 shrink grow"
>
  <div
    pBadge
    badgeStyleClass="!right-1 !top-1 p-badge-contrast"
    [badgeDisabled]="pendingInvitations().length < 1"
  >
    <p-avatar
      [label]="(profileService.initials$ | async) ?? '?'"
      shape="circle"
      size="large"
    />
  </div>
  <div class="flex flex-col w-full">
    <div class="flex">
      <div
        class="shrink grow w-0 overflow-x-hidden whitespace-nowrap overflow-ellipsis"
      >
        {{ this.profileService.name$ | async }}
      </div>
    </div>
    <div class="flex">
      <div
        class="text-sm text-surface-500 shrink grow w-0 overflow-x-hidden whitespace-nowrap overflow-ellipsis"
      >
        {{ this.authService.email$ | async }}
      </div>
    </div>
  </div>
</div>

<p-menu
  #menu
  [popup]="true"
  [model]="items()"
  styleClass="!min-w-[17rem]"
  appendTo="body"
>
  <ng-template #start>
    <div class="flex items-center p-2 gap-2">
      <p-avatar shape="circle" size="large" [icon]="PrimeIcons.USER">
      </p-avatar>
      <div class="flex flex-col">
        <span>
          {{ this.profileService.name$ | async }}
        </span>
        <span class="text-sm text-surface-500">
          {{ this.authService.email$ | async }}
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #item let-item>
    @if (item.url) {
      <a [href]="item.url" class="flex items-center p-menu-item-link">
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.label }}</span>
        @if (item.badge !== undefined) {
          <p-badge
            [severity]="item.badge > 0 ? 'contrast' : 'secondary'"
            class="ml-auto"
            [value]="item.badge"
          />
        }
      </a>
    } @else if (item.routerLink) {
      <a
        [routerLink]="item.routerLink"
        class="flex items-center p-menu-item-link"
      >
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.label }}</span>
        @if (item.badge !== undefined) {
          <p-badge
            [severity]="item.badge > 0 ? 'contrast' : 'secondary'"
            class="ml-auto"
            [value]="item.badge"
          />
        }
      </a>
    } @else {
      <div class="flex items-center p-menu-item-link">
        <span [class]="item.icon"></span>
        <span class="ml-2">{{ item.label }}</span>
        @if (item.badge !== undefined) {
          <p-badge
            [severity]="item.badge > 0 ? 'contrast' : 'secondary'"
            class="ml-auto"
            [value]="item.badge"
          />
        }
      </div>
    }
  </ng-template>
</p-menu>
